module.exports = __webpack_public_path__ + "static/img/calme.049c8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/calme.png
// module id = s83i
// module chunks = 0